module.exports = __webpack_public_path__ + "static/img/Videoamp-Default.a196291.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Videoamp-Default.png
// module id = 1593
// module chunks = 0